const ENTRY_TYPES = {
  PLAIN_TEXT: 'plainText',
  DEFINITION: 'definition',
  IMAGE: 'image',
  EXTERNAL_LINK: 'externalLink',
};

class GlossaryText {
  constructor(params) {
    this._plainText = null;
    this.entries = (params.entries || []).map((entry, index) => ({
      index,
      entryType: entry.entryType,
      text: entry.text,
      value: entry.value || null,
    }));
  }

  getPlainText() {
    if (!this._plainText) {
      const plainText = this.entries.map(entry => entry.text);
      this._plainText = plainText.join('');
    }
    return this._plainText;
  }
}

export { ENTRY_TYPES, GlossaryText };



// WEBPACK FOOTER //
// ./src/models/GlossaryText.js